import React from 'react';
import styled from '@emotion/styled';
import PropTypes, { InferProps } from 'prop-types';
import Subtitle from '../Typography/SubTitle';
import { topRoundedCorners } from '../RoundedCorners';
import colors from '../Theme/colors';
import { executiveColors } from '../Theme/Executive';

const labelPropertyTypes = {
  children: PropTypes.node,
  className: PropTypes.string,
  isExecutive: PropTypes.bool,
};

type LabelProperties = InferProps<typeof labelPropertyTypes>;

const StyledSubtitle = styled(Subtitle)<{ isExecutive?: boolean }>`
  && {
    position: absolute;
    bottom: 0;
    margin: 0;
    min-width: 147px;
    height: 23px;
    text-align: center;
    text-transform: uppercase;
    color: ${colors.white};
    background-color: ${
      (properties) => (properties.isExecutive
        ? executiveColors.primary
        : properties.theme.colors.primary)
    };
    ${topRoundedCorners};
    & > span {
      padding: 0 8px;
    }
    & > span > span {
      padding: 0;
    }
  }
`;

const Label = (
  {
    children,
    className,
    isExecutive,
  }: LabelProperties,
) => (
  <StyledSubtitle
    className={className}
    isExecutive={isExecutive ?? false}
  >
    <span>{children}</span>
  </StyledSubtitle>
);

Label.propTypes = labelPropertyTypes;

export default Label;
